document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('[data-mega-card-tabs]');
  if (!wrappers.length) return;

  const setActiveTabs = (containers, targetId) => {
    containers.forEach((container) => {
      const links = container.querySelectorAll('[data-target]');
      links.forEach((link) => {
        const isActive = link.dataset.target === targetId;
        link.classList.toggle('is-active', isActive);
        link.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    });
  };

  const showCard = (cardMap, targetId) => {
    Object.entries(cardMap).forEach(([id, card]) => {
      const isActive = id === targetId;
      card.classList.toggle('mega-product-cards--hidden', !isActive);
      if (isActive) {
        card.setAttribute('data-mega-card-active', 'true');
      } else {
        card.removeAttribute('data-mega-card-active');
      }
    });
  };

  wrappers.forEach((wrapper) => {
    const links = Array.from(wrapper.querySelectorAll('[data-target]'));
    if (!links.length) {
      return;
    }

    const cardMap = {};
    links.forEach((link) => {
      const id = link.dataset.target;
      if (!id || cardMap[id]) return;
      const card = document.querySelector(`[data-mega-card-id="${id}"]`);
      if (card) {
        cardMap[id] = card;
      }
    });

    const availableIds = links
      .map((link) => link.dataset.target)
      .filter((id) => cardMap[id]);

    if (!availableIds.length) {
      return;
    }

    const floating = wrapper.cloneNode(true);
    floating.classList.add('mega-card-tabs', 'mega-card-tabs--floating');
    floating.removeAttribute('data-mega-card-tabs');
    floating.setAttribute('aria-hidden', 'true');
    floating.classList.remove('scroll-trigger', 'animate--slide-in');
    document.body.appendChild(floating);

    const containers = [wrapper, floating];

    let currentCard = null;
    let floatingState = 'hidden';

    const updateFloatingPosition = () => {
      if (floatingState !== 'visible' || !currentCard) return;
      const pageWidthVar = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--page-width')
      );
      const maxWidth = Number.isNaN(pageWidthVar) ? 1200 : pageWidthVar;
      const width = Math.min(wrapper.offsetWidth, window.innerWidth - 32, maxWidth);
      floating.style.width = `${width}px`;
    };

    const updateFloatingState = () => {
      if (!currentCard) {
        setFloatingVisibility('hidden');
        return;
      }

      const tabsRect = wrapper.getBoundingClientRect();
      const headerHeight =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
          10
        ) || 0;
      const tabsOutOfView = tabsRect.bottom <= headerHeight;

      const cardRect = currentCard.getBoundingClientRect();
      const cardVisible = cardRect.bottom > 0 && cardRect.top < window.innerHeight;

      setFloatingVisibility(tabsOutOfView && cardVisible ? 'visible' : 'hidden');
    };

    const setFloatingVisibility = (state) => {
      if (floatingState === state) {
        if (state === 'visible') updateFloatingPosition();
        return;
      }

      floatingState = state;
      floating.classList.remove('is-visible', 'is-hidden');

      if (state === 'visible') {
        floating.classList.add('is-visible');
        floating.setAttribute('aria-hidden', 'false');
        updateFloatingPosition();
      } else if (state === 'hidden') {
        floating.style.width = '';
        floating.classList.add('is-hidden');
        floating.setAttribute('aria-hidden', 'true');
      }
    };

    const activate = (targetId, updateUrl = false, scrollToCard = false, scrollToTabs = false) => {
      setActiveTabs(containers, targetId);
      showCard(cardMap, targetId);
      currentCard = cardMap[targetId];
      updateFloatingPosition();
      updateFloatingState();

      if (updateUrl) {
        history.replaceState(null, '', `#${targetId}`);
      }

      if (scrollToCard && currentCard) {
        const headerHeight =
          parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
            10
          ) || 0;
        const offset = headerHeight + 32;
        const rect = currentCard.getBoundingClientRect();
        const absoluteTop = window.pageYOffset + rect.top;

        window.scrollTo({
          top: absoluteTop - offset,
          behavior: 'smooth'
        });
      } else if (scrollToTabs) {
        const headerHeight =
          parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
            10
          ) || 0;
        const offset = headerHeight + 16;
        const rect = wrapper.getBoundingClientRect();
        const absoluteTop = window.pageYOffset + rect.top;

        window.scrollTo({
          top: absoluteTop - offset,
          behavior: 'smooth'
        });
      }
    };

    const clickHandler = (event) => {
      const link = event.target.closest('[data-target]');
      if (!link) return;
      event.preventDefault();
      const targetId = link.dataset.target;
      if (!cardMap[targetId]) return;
      const shouldScrollToCard = window.innerWidth >= 990;
      activate(targetId, true, shouldScrollToCard, !shouldScrollToCard);
    };

    containers.forEach((container) => {
      container.addEventListener('click', clickHandler);
    });

    activate(availableIds[0], false);

    const resizeHandler = () => {
      updateFloatingState();
      updateFloatingPosition();
    };
    const scrollHandler = () => {
      updateFloatingState();
      updateFloatingPosition();
    };

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('scroll', scrollHandler, { passive: true });
  });
});

